import Vue from 'vue'
import Router from 'vue-router'
import oidcCallback from '@/components/common/oidcCallback'
import {vuexOidcCreateRouterMiddleware} from 'vuex-oidc'
import store from '../store'

var terminal = "workflow";
if (getMobile()) {
    terminal = "wechat";
}
Vue.use(Router);
Vue.prototype.$global = () => {
    return {terminal}
}

var router = new Router({
    mode: "history",
    base: window.commonApi.PATH ? window.commonApi.PATH : '/',
    routes: [
        {
            path: '/',
            redirect: '/workflow/index'
        },
        {
            path: '/workflow/index',
            name: 'apps',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsTemplate`], resolve)
        },
        {
            path: '/workflow/todo',
            name: 'todo',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsTodoTemplate`], resolve)
        },
        {
            path: '/workflow/apply',
            name: 'apply',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsApplyTemplate`], resolve)
        },
        {
            path: '/workflow/about',
            name: 'about',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsAboutTemplate`], resolve)
        },
        {
            path: '/workflow/doing',
            name: 'doing',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsDoingTemplate`], resolve)
        },
        {
            path: '/workflow/done',
            name: 'done',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsDoneTemplate`], resolve)
        },
        {
            path: '/workflow/appall',
            name: 'appall',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsAppAllTemplate`], resolve)
        },
        {
            path: '/workflow/detail',
            name: 'detail',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsItemDetail`], resolve)
        },
        {
            path: '/workflow/flow_cc',
            name: 'flow_cc',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsCcTemplate`], resolve)
        },
        {
            path: '/workflow/guide',
            name: 'guide',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsGuideTemplate`], resolve)
        },
        {
            path: '/workflow/gl/:glId',
            name: 'gl',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsGlTemplate`], resolve)
        },
        {
            path: '/workflow/infos',
            name: 'infos',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsInfosTemplate`], resolve)
        },
        {
            path: '/workflow/bzsm',
            name: 'bzsm',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/BZSM`], resolve)
        },
        {
            path: '/workflow/lxwm',
            name: 'lxwm',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/LXWM`], resolve)
        },
        {
            path: '/signin-oidc-error',
            redirect: '/'
        },
        {
            path: '/workflow/oidcCallback',
            name: 'oidcCallback',
            component: oidcCallback,
            meta: {
                isVuexOidcCallback: true,
                isPublic: true
            }
        }
    ]
})

function getMobile() {
    var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag === null) {
        return false;
    } else {
        return true;
    }
}

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))
export default router



// WEBPACK FOOTER //
// ./src/router/index.js